import { createContext, type PropsWithChildren, useContext } from 'react'

import { employersEmployees } from 'rails_routes'

interface EditingAllowancesContextType {
  editingAllowances: boolean;
  returnUrl: string;
}

const EditingAllowancesContext = createContext<EditingAllowancesContextType>({
  editingAllowances: false,
  returnUrl: employersEmployees.index(),
})

export function useEditingAllowances () {
  return useContext(EditingAllowancesContext)
}

export function EditingAllowancesProvider ({
  editingAllowances,
  children
}: PropsWithChildren<{ editingAllowances: boolean }>) {
  return (
    <EditingAllowancesContext.Provider value={{
      editingAllowances,
      returnUrl: employersEmployees.index(),
    }}
    >
      {children}
    </EditingAllowancesContext.Provider>
  )
}
